/* ============================================================
   Collection Main JS (collection-main.liquid) – sort select
   ============================================================ */
(function () {
  'use strict';

  const sortSelects = document.querySelectorAll('.js-sort-select');
  sortSelects.forEach((sortSelect) => {
    sortSelect.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location = url.toString();
    });
  });
})();
